<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>退货商品</span>
            <div>
              <el-button type="primary" size="small" @click="_openAddShopHouseModal">
                <i class="el-icon-plus"></i>选择订单商品
              </el-button>
            </div>
          </div>
          <el-table :data="applyReturnOrderrCartManageInfo.orderCarts" style="width: 100%" border stripe>
            <el-table-column prop="cartType" label="类型" align="center">
              <template slot-scope="scope">
                {{ scope.row.cartType == '3307' ? '服务' : '商品' }}
              </template>
            </el-table-column>
            <el-table-column prop="orderId" label="订单编号" align="center"></el-table-column>
            <el-table-column prop="prodName" label="名称" align="center"></el-table-column>
            <el-table-column prop="personName" label="用户" align="center"></el-table-column>
            <el-table-column prop="cartNum" label="购买数量" align="center"></el-table-column>
            <el-table-column prop="payPrice" label="支付金额" align="center"></el-table-column>
            <el-table-column label="退货数量" align="center">
              <template slot-scope="scope">
                <el-input v-model="scope.row.returnCartNum" type="number" @keyup.native="_caculTotalMount"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="单价" align="center"></el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="_deleteProduct(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="pagination" layout="prev, pager, next" :total="total" :page-size="pageSize"
            @current-change="handleCurrentChange">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>说明</span>
          </div>
          <el-form label-width="100px">
            <el-form-item label="总金额">
              <span style="font-size: 14px;color: red;">
                {{ applyReturnOrderrCartManageInfo.totalMount }}
              </span>
            </el-form-item>
            <el-form-item label="退货说明">
              <el-input type="textarea" v-model="applyReturnOrderrCartManageInfo.remark" placeholder="必填，请填写进货说明"
                maxlength="250" show-word-limit>
              </el-input>
            </el-form-item>
          </el-form>
          <div style="text-align: right; margin-top: 20px;">
            <el-button type="warning" @click="_goBack">取消</el-button>
            <el-button type="primary" @click="_doInoutOrder">提交</el-button>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <choose-store-order-cart ref="chooseStoreOrderCart"></choose-store-order-cart>
  </div>
</template>

<script>
import { applyReturnStoreCarts } from '@/api/goods/applyReturnOrderrCartManageApi'
import { getShopId } from '@/api/shop/shopApi'
import ChooseStoreOrderCart from '@/components/goods/chooseStoreOrderCart'

export default {
  name: 'ApplyReturnOrderrCartManage',
  components: {
    ChooseStoreOrderCart
  },
  data() {
    return {
      applyReturnOrderrCartManageInfo: {
        rsId: '',
        supplierName: '',
        orderCarts: [],
        remark: '',
        totalMount: 0.00,
        orderType: '10000',
        shopId: ''
      },
      total: 0,
      pageSize: 10
    }
  },
  created() {
    this.applyReturnOrderrCartManageInfo.shopId = getShopId()
    console.log(this.total)
    console.log(this.pageSize)
  },
  methods: {
    _doInoutOrder() {
      const _orderCarts = this.applyReturnOrderrCartManageInfo.orderCarts
      if (_orderCarts.length < 1) {
        this.$message.warning('请选择商品')
        return
      }

      try {
        _orderCarts.forEach(item => {
          if (!item.returnCartNum || item.returnCartNum <= 0) {
            this.$message.warning("请输入正确的退货数量")
            throw new Error()
          }
          if (parseInt(item.returnCartNum) > parseInt(item.cartNum)) {
            this.$message.warning("退货数量不能大于购买数量")
            throw new Error()
          }
        })

        if (!this.applyReturnOrderrCartManageInfo.remark) {
          this.$message.warning('请填写退货说明')
          return
        }

        applyReturnStoreCarts(this.applyReturnOrderrCartManageInfo)
          .then(response => {
            if (response.code === 0) {
              this.$message.success(response.msg)
              // this.$router.go(-1)
            }
          })
          .catch(error => {
            console.error('请求失败:', error)
            this.$message.error(error)
          })
      } catch (e) {
        return
      }
    },
    _openAddShopHouseModal() {
      this.$refs.chooseStoreOrderCart.open()
    },
    _goBack() {
      this.$router.go(-1)
    },
    _deleteProduct(_inoutOrderProduct) {
      const index = this.applyReturnOrderrCartManageInfo.orderCarts.indexOf(_inoutOrderProduct)
      if (index > -1) {
        this.applyReturnOrderrCartManageInfo.orderCarts.splice(index, 1)
      }
    },
    _caculTotalMount() {
      let total = 0
      try {
        this.applyReturnOrderrCartManageInfo.orderCarts.forEach(item => {
          if (!isNaN(item.returnCartNum)) {
            total += parseFloat(item.returnCartNum) * parseFloat(item.price)
          } else {
            this.applyReturnOrderrCartManageInfo.totalMount = "请输入正确的数字"
            throw new Error()
          }
        })
        this.applyReturnOrderrCartManageInfo.totalMount = total.toFixed(2)
      } catch (e) {
        return
      }
    },
    handleCurrentChange(val) {
      console.log(val)
    }
  }
}
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>